export const createRandomString = (length) => {
  let str = ''
  while (str.length < length) {
    str += Math.random().toString(36).substr(2)
  }
  return str
}

const InputGroup = (props) => {
  const restriction = typeof props.maxlength !== 'undefined' ? <span className='restriction pull-right'>Max. {props.maxlength} characters</span> : ''
  const id = createRandomString(8)

  return <div className='form-group'>
    <label htmlFor={id}>{props.title}</label>
    {restriction}
    {props.meta ? <p>{props.meta}</p> : null}
    <input
      className={`form-control ${props.qaClasses || ''} ${props.error && props.error !== '' ? 'validation-error' : ''}`}
      type={props.type}
      id={id}
      value={props.value}
      onKeyUp={props.onChange}
      required={props.required}
      disabled={props.disabled}
      maxLength={props.maxlength}
      placeholder={props.placeholder}
      pattern={props.pattern} />
    { props.error && props.error !== '' ? <div className='validation-error'>{props.error}</div> : null }
  </div>
}

export default InputGroup
